import React from 'react';
import styled from 'styled-components';

const ModifyTitle = ({ title }) => {
  return (
    <ModifyTitleContainer>
      <ModifyTitleText className='font-weight-bold'>{title}</ModifyTitleText>
    </ModifyTitleContainer>
  );
};

const ModifyTitleContainer = styled.section`
  height: 36px;
  border-bottom: 2px solid black;
`;
const ModifyTitleText = styled.h5`
  font-size: 17px;
`;

export default ModifyTitle;
